<template>
    <div class="mortgage-program-accordeon__content">
        <div class="mortgage-program-accordeon _dflex _justify-content-between" :class="{'mortgage-program-accordeon_active': visible}" @click="changeVisibility">
            <h3 class="h3"> {{ detailText }} </h3>
            <button class="mortgage-program-accordeon__button" :class="{'mortgage-program-accordeon__button_inverted': !visible}"></button>
        </div>
        <slot name="header"></slot>
        <div :class="{'_dblock': visible}" v-show="visible"><slot name="main"></slot></div>
    </div>
</template>

<script>
export default {
    name: "MortgageAccordeon",
    props: {
        detailText: {
            type: String,
            default: 'Подробнее об условиях'
        },
        visibility: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            triggeredBy: ''
        }
    },
    methods: {
        changeVisibility() {
            this.visible = !this.visible;
            this.triggeredBy = 'user';
        }
    },
    updated() {
        if (this.triggeredBy === 'user') {
            this.triggeredBy = 'auto';
        }
        else if (this.triggeredBy !== 'user' && !this.$props.visibility)  {
            this.visible = false;
        }
    },
    mounted() {
        this.visible = this.$props.visibility ? true : false;
    }
}
</script>
